import { Box } from 'src/design/atoms/Box';
import { Grid } from 'src/design/atoms/Grid';
import React from 'react';
import { useDrag } from 'react-dnd';
import { Rate } from 'src/api/FiretrolApiClient';
import { DeleteButton } from 'src/design/atoms/DeleteButton';
import { DragTypes } from './DragTypes';

export interface IDraggableItemProps {
  rate: Rate;
  onRemove: () => void;
}

export const DraggableItem: React.FC<IDraggableItemProps> = ({
  rate,
  onRemove,
}) => {
  const [{ opacity, cursor }, drag] = useDrag({
    type: DragTypes.RATE,
    item: {
      data: {
        ...rate,
      },
    },
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.5 : 1,
      cursor: monitor.isDragging() ? 'grabbing' : 'grab',
    }),
  });
  return (
    <Box
      role={DragTypes.RATE}
      ref={drag}
      style={{
        opacity,
        cursor,
        border: '1px dashed #ced9e0',
      }}
      px="xs"
      mb="xs"
    >
      <Grid>
        <Grid.Col span={6}>
          <Box py="xs">{rate.label}</Box>
        </Grid.Col>
        <Grid.Col span="auto" ta="right">
          <DeleteButton size="compact-sm" onClick={onRemove} />
        </Grid.Col>
      </Grid>
    </Box>
  );
};
